// @flow
import React from 'react';
import {makeStyles} from '@material-ui/core';
import TitleHeaderTableOrder from 'common/componentsV2/table/TitleHeaderTableOrder';
import tableColumns from 'channels/constants/tableColumns';
import {StringParam, useQueryParams} from 'use-query-params';

const useStyles = makeStyles((theme) => ({
  container: {
    marginBottom: '8px',
    height: '23px',
    display: 'flex',
    alignItems: 'center',
    position: 'relative',
    zIndex: 1,
    width: '100%',
    '&.sep-down': {
      boxShadow: '0 3px 2px -2px rgba(0, 0, 0, 0.175)',
    },
  },
  header: {
    flexShrink: 0,
    overflow: 'hidden',
    fontSize: '12px',
    fontWeight: 400,
    color: theme.palette.gray[400],
  },
  title: {
    flexGrow: 1,
    marginLeft: '32px',
  },
  alertsConnected: {
    width: '170px',
  },
  dateCreated: {
    width: '147px',
  },
  owner: {
    width: '170px',
  },
}));

const ChannelsListHeader = () => {
  const [{sort, order}, setQueryParams] = useQueryParams({
    sort: StringParam,
    order: StringParam,
  });

  const classes = useStyles();

  const handleTitleOrderChange = (columnName) => {
    let updatedDirection = 'desc';

    if (columnName === sort) {
      updatedDirection = order === 'desc' ? 'asc' : 'desc';
    }
    setQueryParams({sort: columnName, order: updatedDirection});
  };

  return (
    <div className={classes.container}>
      {tableColumns.map((field) => (
        <div key={field.id} className={`${classes.header} ${classes[field.name]}`}>
          <TitleHeaderTableOrder
            onChange={handleTitleOrderChange}
            title={field.title}
            selectedDirection={order}
            columnName={field.name}
            isSortable={field.isSortable}
            isActive={field.name === sort}
          />
        </div>
      ))}
    </div>
  );
};

export default ChannelsListHeader;
